import React from 'react';
import PropTypes from 'prop-types';

import ListingActivationConstants from 'app/shared/constants/ListingActivationConstants';

// Multibrand-UI Components
import Link from '@zg-rentals/multibrand-ui/lib/Link';
import Text from '@zg-rentals/multibrand-ui/lib/Text';

import './style.scss';

const ActivationErrorModal = ({
    error,
}) => {
    let errorMessage;
    let errorItems = [];

    switch (error.code) {
        case ListingActivationConstants.ERROR_CODE.INVALID_FIELDS:
            errorMessage = 'We found some invalid fields while activating your listing.';
            if (error.data.listing) {
                errorItems = Object.values(error.data.listing);
            }
            if (error.data.floorPlans) {
                errorItems.push('Please fix the errors in your floorplans.');
            }
            break;
        case ListingActivationConstants.ERROR_CODE.LISTING_ACTIVATION_BLOCKED:
            errorMessage = (
                <React.Fragment>
                    We&apos;re unable to activate this listing at this time. Please contact&nbsp;
                    <Link href={`mailto:${error.data.accountVerificationEmail}`} escape={true}>
                        {error.data.accountVerificationEmail}
                    </Link>
                </React.Fragment>
            );
            break;
        default:
            errorMessage = error.message;
    }

    return (
        <div className="PostActivationModal-errors">
            <Text>
                {errorMessage}
            </Text>
            <ul>
                {errorItems.map(errorItem => <li>{errorItem}</li>)}
            </ul>
        </div>
    );
};

ActivationErrorModal.defaultProps = {
    error: null,
};

ActivationErrorModal.propTypes = {
    error: PropTypes.object,
};

export { ActivationErrorModal };
export default ActivationErrorModal;
